// extracted by mini-css-extract-plugin
export var chevron = "StrapiLink-module--chevron--c6e79";
export var link = "StrapiLink-module--link--a6ced";